<div class="currency-wrap" *ngIf="prefix">
  <span class="currency-code">{{ prefix }}</span>
  <label for="urlTextFieldPrefixed" class="sr-only">Value</label>
  <input
    id="urlTextFieldPrefixed"
    type="text"
    class="form-control text-currency"
    [value]="valueFromApi"
    [disabled]="disabled"
  />
</div>

<div *ngIf="!prefix">
  <label for="urlTextField" class="sr-only">Value</label>
  <input
    id="urlTextField"
    type="text"
    class="form-control"
    [value]="valueFromApi"
    [disabled]="disabled"
  />
</div>
